import { DayView } from "../DayView"
import { Loading } from "../../Components/Loading"
import { TripDaysViewProps } from "./Params"

// The TripView body: the caller-provided children, or the gap-filled day list (a
// DayView per recorded day AND per synthetic gap -- gaps route through the same
// full DayView rather than the old inert BlankDayView, #1137, so a day with zero
// logs is still fully clickable through to its Day-tab/Notes detail view), or a
// Loading placeholder while the days are still being fetched.
export function TripDaysView({ children, daysWithBlanks }: TripDaysViewProps) {
  if (children) {
    return <>{children}</>;
  }
  if (!daysWithBlanks) {
    return <Loading />;
  }
  return (
    <>
      {daysWithBlanks.map((day) => <DayView key={`day-${day.id}-${day.day}`} day={day} />)}
    </>
  );
}
